/**
 * The AP settings screen's route (FSD FIN-FR-006, 2.2.2).
 *
 * A per-feature file so the integration packet spreads it into the router;
 * nothing here edits `ap/routes.ts`, `ap/routesC3.ts` or the router itself.
 *
 * The permission is the one both `GET` and `PUT /api/v1/ap-settings` declare in
 * `server/internal/ap/handler.go`: `ap.settings.manage`. Reading is guarded by
 * it too, so there is no read-only variant of this screen to offer.
 */

import type { RouteRecordRaw } from 'vue-router'

import { AP_PERMISSIONS } from '@/modules/ap/permissions'

export const AP_SETTINGS_ROUTES: RouteRecordRaw[] = [
  {
    path: '/ap/settings',
    name: 'ap-settings',
    component: () => import('@/modules/ap/settings/ApSettingsView.vue'),
    meta: { titleKey: 'ap.routeTitles.settings', permission: AP_PERMISSIONS.settingsManage },
  },
]
